module.exports = __webpack_public_path__ + "static/img/AkkuratPro-Bold.d9f993a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/AkkuratPro-Bold.svg
// module id = 74BW
// module chunks = 1